import { render } from "./HistoryBuy.vue?vue&type=template&id=7b4763e2"
import script from "./HistoryBuy.vue?vue&type=script&lang=js"
export * from "./HistoryBuy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__